// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    function adjustHeight(event) {
        if (event.data !== null) {
            var searchPhrase = "iframe[id='" + event.data.id + "']";
            var iframe = $(searchPhrase);
            if (iframe !== null) {
                if (iframe.attr("origin") !== null && iframe.attr("origin") == event.origin) {
                    var newHeight = event.data.height;
                    if (!isNaN(newHeight) && newHeight > 0) {
                        iframe.attr('height', newHeight);
                    }
                }
                // Support for old version code (does not support multiple iframe spots on the same page)

                if (!event.data.height) {
                    iframe = $("iframe");
                    var newHeight = event.data;
                    if (!isNaN(newHeight) && newHeight > 0) {
                        iframe.attr('height', newHeight);
                    }
                }

                /* Before and After gallery iframe specific code ("jump" to top of iframe) */
                if (event.data.scrollTop === true) {
                    $('html, body').delay(200).animate({
                        scrollTop: $("iframe#" + event.data.id).parents("section").offset().top
                    }, 800);
                }

            }
        }
    }
    $(document).ready(function () {
        window.addEventListener("message", adjustHeight, false);
    });

})(window, document, jQuery);